import React, { useState } from "react";
import { useEffect } from "react";
import { Button, Collapse, Input, Label } from "reactstrap";
import { getSettingByKey, toArray } from "../../../../helpers/common";
import { useSelector } from "react-redux";


const SalaryRange = ({ onFilterChange, searchParams, handleClearFilter }) => {
  const [toggleThird, setToggleThird] = useState(false);
  const [checked, setChecked] = useState([]);

  // ✅ Read unified 'SalaryRange' parameter from URL
  const salaryRangeParam = searchParams.get("SalaryRange");

  const settings = useSelector((state) => state.settings.data);

  // Helper to split string into array
  const toArray = (str, delim) =>
    str ? str.split(delim).map((s) => s.trim()).filter(Boolean) : [];

  const salaryRangeList = toArray(
    getSettingByKey(settings, "salary_range")?.value,
    "\n"
  );

  // Sync state with URL query param `SalaryRange`
  useEffect(() => {
    if (salaryRangeParam) {
      setChecked(salaryRangeParam.split(","));
    } else {
      setChecked([]);
    }
  }, [salaryRangeParam]);

  // Handle Checkbox Toggles
  const handleToggle = (value) => {
    window.scrollTo({
      top: 250,
      behavior: "smooth",
    });

    let updatedChecked = [...checked];
    const index = updatedChecked.indexOf(value);

    if (index === -1) {
      updatedChecked.push(value);
    } else {
      updatedChecked.splice(index, 1);
    }

    if (updatedChecked.length > 0) {
      setChecked(updatedChecked);
      // ✅ Pass multi-selected ranges as comma-separated values (e.g. "10000-20000,20000-30000")
      onFilterChange("SalaryRange", updatedChecked.join(","));
    } else {
      setChecked([]);
      handleClearFilter("SalaryRange");
    }
  };

  return (
    <div className="accordion-item border rounded-3 shadow-sm overflow-hidden mt-3">
      <h2 className="accordion-header" id="salaryRange">
        <Button
          className={`accordion-button fw-bold bg-white text-dark py-3 px-4 shadow-none d-flex justify-content-between align-items-center ${
            toggleThird ? "" : "collapsed"
          }`}
          onClick={(e) => {
            e.preventDefault();
            setToggleThird(!toggleThird);
          }}
          role="button"
        >
          <span>Salary Range Monthly</span>
          {checked.length > 0 && (
            <span className="badge bg-soft-primary text-primary rounded-pill fs-12 px-2 py-1 me-3">
              {checked.length} Selected
            </span>
          )}
        </Button>
      </h2>

      <Collapse isOpen={toggleThird}>
        <div className="accordion-body bg-white p-4 pt-2">
          <div className="side-title">
            {/* --- All Options / Clear Selection --- */}
            <div className="form-check d-flex align-items-center py-1 rounded transition-all">
              <input
                className="form-check-input cursor-pointer"
                type="checkbox"
                id="salaryAll"
                checked={!salaryRangeParam}
                onChange={() => {
                  setChecked([]);
                  handleClearFilter("SalaryRange");
                }}
              />
              <Label
                className={`form-check-label ms-2 cursor-pointer w-100 ${
                  !salaryRangeParam ? "text-dark fw-semibold" : "text-muted"
                }`}
                htmlFor="salaryAll"
              >
                All Salary Ranges
              </Label>
            </div>

            {/* --- Dynamic Checkbox Render Loop --- */}
            {salaryRangeList?.map((item, index) => {
              const isSelected = checked.includes(item);
              return (
                <div
                  className="form-check d-flex align-items-center py-1 mt-2 rounded transition-all"
                  key={`salary-range-${index}`}
                >
                  <Input
                    className="form-check-input cursor-pointer"
                    type="checkbox"
                    id={`${item}-flexCheckboxDefault`}
                    checked={isSelected}
                    onChange={() => handleToggle(item)}
                  />
                  <Label
                    className={`form-check-label ms-2 cursor-pointer w-100 ${
                      isSelected ? "text-dark fw-semibold" : "text-muted"
                    }`}
                    htmlFor={`${item}-flexCheckboxDefault`}
                  >
                    ₹{item}
                  </Label>
                </div>
              );
            })}
          </div>
        </div>
      </Collapse>
    </div>
  );
};

export default SalaryRange;